import React from 'react'
import { Button, Typography } from '@mui/material'
import classNames from 'classnames'
import { withStyles } from 'tss-react/mui'
import Wrapper from '@app/components/Common/Wrapper/Wrapper'
import styles from './RoomsStatsItem.style'

interface Props {
  classes: Record<string, string>,
  className?: string,
  name: string,
  billing: number,
  energy: number,
  isRoomsStatsPopupOpen?: boolean,
  isMobile: boolean,
  openRoomStatsPopup: (...args: any[]) => void,
  id: number,
  selectCurrentRoomIdAndName: (...args: any[]) => void,
  syncCurrentRoomStats: (...args: any[]) => void,
}

class RoomsStatsItem extends React.Component<Props> {
  RoomStatsOpen = () => {
    const {
      openRoomStatsPopup,
      selectCurrentRoomIdAndName,
      id,
      name,
      syncCurrentRoomStats,
    } = this.props
    selectCurrentRoomIdAndName(id, name)
    syncCurrentRoomStats()
    openRoomStatsPopup()
  }

  render() {
    const {
      classes,
      name,
      billing,
      energy,
      isMobile,
    } = this.props
    return (
      <Wrapper className={classes.listItem}>
        <Wrapper className={classes.itemHeader}>
          <Typography className={classes.roomName}>{name}</Typography>
          <Typography className={classes.roomPeriod}>{I18n.t('my_energy.today')}</Typography>
        </Wrapper>
        <Wrapper>
          <Typography className={classes.roomStats}>
            {`${I18n.t('my_energy.kilowatt_title')}: ${energy} ${I18n.t('my_energy.power_kwh')}`}
          </Typography>
          <Typography className={classes.roomStats}>{`${I18n.t('my_energy.dollar_title')}: ${billing} $`}</Typography>
        </Wrapper>
        <Wrapper className={classes.buttonStatWrapper}>
          <Button
            className={classNames(
              classes.buttonStat,
              !isMobile && classes.buttonStatDesktop,
            )}
            color="primary"
            onClick={() => {
              this.RoomStatsOpen()
            }}
          >
            See more
          </Button>
        </Wrapper>
      </Wrapper>
    )
  }
}
export default withStyles(RoomsStatsItem, styles as any) as unknown as React.ComponentType<Omit<Props, 'classes'>>
